/**
 * `POST /v1/telemetry/boot` (LL-49 boot rescue kit), sent with `navigator.sendBeacon`.
 * Fire-and-forget: the server answers 204 and never errors back to the page.
 */
import { z } from 'zod';
export const BOOT_EVENTS = ['ok', 'slow', 'stuck', 'start_fresh', 'chunk_error', 'old_browser', 'error'];
export const BootTelemetrySchema = z.object({
    event: z.enum(BOOT_EVENTS),
    /** ms since navigation start. */
    ms: z.number().int().min(0).max(3_600_000),
    build: z.string().max(64).optional(),
    /** `navigator.connection.effectiveType`, when available. */
    net: z.string().max(16).optional(),
    ua: z.string().max(256).optional(),
    /** Error message or chunk URL, truncated. */
    detail: z.string().max(512).optional(),
    reloads: z.number().int().min(0).max(10).optional(),
});
